<button *ngIf="!required" mat-mini-fab color="accent" (click)="done.emit(undefined)">
  <mat-icon>close</mat-icon>
</button>
<form [formGroup]="form" fxLayout="column" fxLayoutAlign="center flex-end">
  <mat-form-field>
    <mat-label>{{label}}</mat-label>
    <mat-select formControlName="code" [compareWith]="compare" [multiple]="multiple" [required]="required">
      <mat-option *ngFor="let type of codedValues" [value]="type">
        {{type.name}}
      </mat-option>
    </mat-select>
    <mat-hint *ngIf="!required">Click droit sur la carte pour fermer</mat-hint>
  </mat-form-field>

  <button mat-icon-button (click)="validate()" type="button" [disabled]="form.invalid">
    <mat-icon>done</mat-icon>
  </button>
</form>
